









































import { Component, Watch, Prop } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import Card from '@/models/Accounts/Shared/Cards/Card';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import UpdateCardRequest from '@/models/Accounts/Shared/Cards/UpdateCardRequest';
import ProductType from "@/models/Products/ProductType";

@Component({ name: 'CardEdit' })
export default class extends SaascadaVueDialog {

    dialog = false;
    request: UpdateCardRequest = new UpdateCardRequest(null);

    @Prop({required: true})
    card: Card;

    @Prop({required: true})
    productType: ProductType;

    @Prop({required: true})
    pageNumber: number;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateCardRequest(this.card);
        }
    }

    async cancel() {
        this.dialog = false;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            if (this.productType === ProductType.Deposit) {
                await DepositAccountModule.editCard(this.request);
                await DepositAccountModule.getCards(this.pageNumber);
            }
        }
    }

}
